import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-5"
}
const _hoisted_2 = { class: "card-header card-header-stretch pb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "m-0" }, "Способи оплати")
], -1)
const _hoisted_4 = { class: "card-toolbar m-0" }
const _hoisted_5 = {
  class: "nav nav-stretch nav-line-tabs border-transparent",
  role: "tablist"
}
const _hoisted_6 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_7 = {
  class: "btn btn-primary px-6 align-self-center text-nowrap",
  "data-bs-toggle": "tooltip",
  title: "Копіювати платіжний код у буфер обміну"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clipboard" }, null, -1)
const _hoisted_9 = {
  id: "kt_billing_payment_tab_content",
  class: "card-body tab-content"
}
const _hoisted_10 = {
  id: "kt_billing_creditcard",
  class: "tab-pane fade show active",
  role: "tabpanel"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-5" }, "Оберіть спосіб оплати", -1)
const _hoisted_12 = { class: "row gx-9 gy-6" }
const _hoisted_13 = { class: "col-xl-12" }
const _hoisted_14 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-12 p-6" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<span class=\"svg-icon svg-icon-2tx svg-icon-warning me-4\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><rect opacity=\"0.3\" x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"10\" fill=\"black\"></rect><rect x=\"11\" y=\"14\" width=\"7\" height=\"2\" rx=\"1\" transform=\"rotate(-90 11 14)\" fill=\"black\"></rect><rect x=\"11\" y=\"17\" width=\"2\" height=\"2\" rx=\"1\" transform=\"rotate(-90 11 17)\" fill=\"black\"></rect></svg></span>", 1)
const _hoisted_16 = { class: "d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 mb-md-0 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-900 fw-bolder" }, "Важлива примітка!"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-700 pe-7" }, " Ви маєте можливість скопіювати платіжний код у буфер обміну, для подальшої оплати по ньому, натиснувши на кнопці зі своїм кодом або на Скопіювати. ")
], -1)
const _hoisted_18 = {
  class: "btn btn-secondary px-6 align-self-center text-nowrap",
  "data-bs-toggle": "tooltip",
  title: "Копіювати платіжний код у буфер обміну"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clipboard" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Копіювати ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "col-xl-12"
}
const _hoisted_23 = { class: "card card-dashed h-xl-100 flex-row flex-stack flex-wrap flex-md-wrap flex-lg-nowrap flex-sm-wrap p-6" }
const _hoisted_24 = { class: "d-flex flex-column py-2 w-100" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center fs-4 fw-bolder mb-5" }, [
  /*#__PURE__*/_createTextVNode(" Онлайн оплата "),
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-success fs-7 ms-2" }, "Основний")
], -1)
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: "media/logos/privat.jpg",
  alt: "",
  class: "me-4",
  style: {"width":"20%"}
}, null, -1)
const _hoisted_28 = { class: "w-75" }
const _hoisted_29 = { class: "fs-4 fw-bolder" }
const _hoisted_30 = { class: "fs-6 fw-bold text-gray-400 mt-3 text-wrap" }
const _hoisted_31 = { class: "d-flex flex-column align-items-end py-2 w-100" }
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "col-xl-12" }
const _hoisted_34 = { class: "card card-dashed h-xl-100 flex-row flex-stack flex-wrap flex-md-wrap flex-lg-nowrap flex-sm-wrap p-6" }
const _hoisted_35 = { class: "d-flex flex-column py-2 w-100" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center fs-4 fw-bolder mb-5" }, " Портмоне ", -1)
const _hoisted_37 = { class: "d-flex align-items-center" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", {
  src: "media/logos/portmone-logo-og.png",
  alt: "",
  class: "me-4 w-25"
}, null, -1)
const _hoisted_39 = { class: "w-75" }
const _hoisted_40 = { class: "fs-4 fw-bolder" }
const _hoisted_41 = { class: "fs-6 fw-bold text-gray-400" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-end py-2 w-100" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.portmone.com.ua/r3/uk/terminal/index/index/id/69806",
    target: "_blank",
    class: "btn btn-sm btn-light btn-active-light-primary"
  }, "До сплати")
], -1)
const _hoisted_43 = { class: "col-xl-12" }
const _hoisted_44 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed h-lg-100 p-6" }
const _hoisted_45 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_46 = { class: "d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap" }
const _hoisted_47 = { class: "mb-3 mb-md-0 fw-bold" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-900 fw-bolder" }, " Оплата послуг через інтернет за допомогою банківської картки Приват24! ", -1)
const _hoisted_49 = { class: "fs-6 text-gray-700 pe-7" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Кошти надходять на рахунок абонента протягом: "),
  /*#__PURE__*/_createElementVNode("strong", null, "30 хв."),
  /*#__PURE__*/_createTextVNode(" Для оплати у платіжній систем "),
  /*#__PURE__*/_createElementVNode("strong", null, "Приват24"),
  /*#__PURE__*/_createTextVNode(" зайдіть: ")
], -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("li", null, "Усі послуги", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("li", null, "Комуналка", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("li", null, "Оплата заборгованості", -1)
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" У полі пошуку введіть ЄДРПОУ підприємства ")
const _hoisted_55 = { style: {"font-weight":"bold"} }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" або назва підприємства ")
const _hoisted_57 = { style: {"font-weight":"bold"} }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" або скопіюйте ")
const _hoisted_59 = {
  class: "btn btn-sm btn-primary p-3 align-self-center text-nowrap",
  "data-bs-toggle": "tooltip",
  title: "Копіювати Розрахунковий рахунок код у буфер обміну"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clipboard" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Розрахунковий рахунок ")
const _hoisted_62 = [
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("li", null, " Ввести платіжний код із картки профілю користувача. ", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("li", null, " Перевірити домашню адресу у Призначенні платежу, додати до кошика та оплатити. ", -1)
const _hoisted_65 = { class: "col-xl-12" }
const _hoisted_66 = { class: "notice d-flex bg-light-warning rounded border-primary border border-dashed h-lg-100 p-6" }
const _hoisted_67 = { class: "svg-icon svg-icon-2tx svg-icon-danger me-4" }
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap\"><div class=\"mb-3 mb-md-0 fw-bold\"><h4 class=\"text-gray-900 fw-bolder\"> Оплата за платіжним кодом або розрахунковим! </h4><div class=\"fs-6 text-gray-700 pe-7\"><p> Рекомендований спосіб оплати за <strong>Платіжним кодом</strong></p><ul><li> При оплаті за Платіжним кодом оплачувана сума зараховується на рахунок протягом 5 хв. </li><li> При оплаті на розрахунковий рахунок фірми, оплачувана сума зараховується на рахунок протягом 3-х робочих банківських днів. </li><li> Якщо Ви сплатили на розрахунковий рахунок фірми, Ви можете надіслати квитанцію з оплатою, скориставшись формою відправки квитанції, перейшовши за <a href=\"//norma4.tv\" target=\"_blank\">цим посиланням</a></li></ul></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_ctx.currentUser && _ctx.currentUser.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.currentUser.settings.settings.payment_code), 1)
                ])), [
                  [_directive_clipboard, _ctx.currentUser.settings.settings.payment_code, "copy"],
                  [_directive_clipboard, _ctx.onCopy, "success"],
                  [_directive_clipboard, _ctx.onCopyError, "error"]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_18, _hoisted_21)), [
                      [_directive_clipboard, _ctx.currentUser.settings.settings.payment_code, "copy"],
                      [_directive_clipboard, _ctx.onCopy, "success"],
                      [_directive_clipboard, _ctx.onCopyError, "error"]
                    ])
                  ])
                ])
              ]),
              (
                          _ctx.currentUser.user.firm != undefined &&
                          _ctx.currentUser.user.firm.payment_link != ''
                        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.currentUser.user.firm.label), 1),
                            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.currentUser.user.firm.code), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("a", {
                          href: _ctx.currentUser.user.firm.payment_link,
                          target: "_blank",
                          class: "btn btn-sm btn-light btn-active-light-primary"
                        }, "До сплати", 8, _hoisted_32)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.currentUser.user.firm.label), 1),
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.currentUser.user.firm.code), 1)
                      ])
                    ])
                  ]),
                  _hoisted_42
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("span", _hoisted_45, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen046.svg" })
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("ul", null, [
                          _hoisted_51,
                          _hoisted_52,
                          _hoisted_53,
                          _createElementVNode("li", null, [
                            _hoisted_54,
                            _createElementVNode("strong", _hoisted_55, _toDisplayString(_ctx.currentUser.user.firm.okpo), 1),
                            _hoisted_56,
                            _createElementVNode("strong", _hoisted_57, _toDisplayString(_ctx.currentUser.user.firm.label), 1),
                            _hoisted_58,
                            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_59, _hoisted_62)), [
                              [_directive_clipboard, _ctx.currentUser.user.firm.code, "copy"],
                              [_directive_clipboard, _ctx.onCopy, "success"],
                              [_directive_clipboard, _ctx.onCopyError, "error"]
                            ])
                          ]),
                          _hoisted_63,
                          _hoisted_64
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("span", _hoisted_67, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen045.svg" })
                  ]),
                  _hoisted_68
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}